<template>
  <div class="corp-container">
    <top-nav :shrinked="true"/>
    <div class="list-content">
      <div class="work-list">
        <div v-for="(item,index) in workList" :key="index" class="work-list-item" @click="workClick(item,index)">
          <div class="work-list-item-left">
           <img :src="item.coverImage" @error="onImageError">
          </div>
          <div class="work-list-item-right">
            <div class="date-content">
                <div>
                    <span>{{item.day}}</span>
                    <span>{{item.date}}</span>
                </div>
            </div>
            <div class="list-text-content">
              <div class="title ellipsis">{{item.title}}</div>
              <div class="content title-line2" v-html="item.content"></div>
            </div>
          </div>
        </div>
      </div>
      <!--  分页  -->
      <div class="footer-page" style="justify-content:center;">
        <div>
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-size="pageSize"
                    :pager-count="pagerCount"
                    prev-text="上一页"
                    next-text="下一页"
                    layout="prev, pager, next"
                    :total="total">
            </el-pagination>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  import topNav from '@/components/base/top-nav'
  import {fetchList} from '@/api/corporate.js';
  import {formatTime,formatUrl} from '@/utils';
  import errorImg from '@/assets/error.jpg';
  export default {
    name: "news",
    components:{
      topNav
    },
    data() {
      return {
        offsetTop:0,
        isFixed: false, // 标记吸顶元素是否应该被固定在页面顶部
        selectedIndex:0,
        total: 0,
        pageSize: 10,
        currentPage: 1,
        pagerCount:5,
        workName: '',
        address: '',
        cate: '',
        addressArr:[{
          label:'常州',
          value: '0'
        },{
          label:'无锡',
          value: '1'
        },{
          label:'泰州',
          value: '2'
        }],
        cateArr:[{
          label:'地产',
          value: '0'
        },{
          label:'资管',
          value: '1'
        }],
        workList:[]
      }
    },
    mounted() {
        this.fetchData()
    },
    methods: {
        onImageError(event){
            event.target.src = errorImg;
        },
        fetchData(){
            let data = {
                current:this.currentPage,
                size: this.pageSize
            }
            fetchList(data).then(res => {
                let data = res.data;
                data.records.forEach(record =>{
                    record.createTime = formatTime(record.createTime,'yyyy.MM.dd')
                    let date_str = record.createTime
                    if(date_str && date_str.length >= 10){
                        record.day = date_str.substr(date_str.length-2,2)
                        record.date = date_str.substr(0,date_str.length-3)
                    }
                    if(record.coverImage){
                        record.coverImage = formatUrl(record.coverImage)
                    }else{
                        record.coverImage = ''
                    }
                })
                this.workList = data.records
                this.total = data.total
            })
        },
      handleScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop; // 获取当前滚动位置
        this.isFixed = scrollTop > this.offsetTop ? true : false//当滚动条大于吸顶距离顶部的距离试,就加上css样式
      },
      menuClick(item,index){
        this.selectedIndex = index;
      },
        handleSizeChange(val) {
            this.pageSize = val
            this.fetchData()
        },
        handleCurrentChange(val) {
            this.currentPage = val
            this.fetchData()
        },
      /**
       * 职位搜索
       */
      onSearch(){

      },
      addressChange(e){
        console.log("e====",e)
      },
      cateChange(e){
        console.log("e22====",e)
      },
      workClick(item,index){
          const routeData = this.$router.resolve({
              path: '/corpdetail', // 假设已经定义了名为NewPage的路由
              query: {
                  id: item.id
              }
          });
          window.open(routeData.href, '_blank');
      }
    }
  }
</script>

<style>
  @import "../../styles/corplist.css";
</style>
<style lang="scss" scoped>
  .work-search{
    ::v-deep .el-input__inner{
      border-radius: 0;
    }
    ::v-deep .el-button{
      border-radius: 0;
    }
    ::v-deep .el-button--primary{
      background-color: #3063A3;
      border-color: #3063A3;
    }
    ::v-deep .el-input__inner:focus {
      border-color: #3063A3;
    }
  }
</style>
